import PropTypes from 'prop-types';
import { Box, Typography, Tooltip, Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export default function BirthdayBanner({ userName }) {
    return (
        <Tooltip title={`Happy Birthday ${userName}! 🎉🎂`} arrow>
            <Chip
                icon={<Iconify icon="noto:party-popper" width={20} />}
                label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 600,
                                background: (theme) =>
                                    `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.warning.main} 100%)`,
                                backgroundClip: 'text',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            }}
                        >
                            Happy Birthday!
                        </Typography>
                        <Iconify icon="noto:birthday-cake" width={20} />
                    </Box>
                }
                sx={{
                    height: 40,
                    px: 1,
                    background: (theme) =>
                        `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.08)} 0%, ${alpha(
                            theme.palette.warning.main,
                            0.08
                        )} 100%)`,
                    border: (theme) => `1px solid ${alpha(theme.palette.success.main, 0.3)}`,
                    animation: 'pulse 2s ease-in-out infinite',
                    '@keyframes pulse': {
                        '0%, 100%': {
                            transform: 'scale(1)',
                            boxShadow: `0 0 0 0 ${alpha('#4caf50', 0.4)}`,
                        },
                        '50%': {
                            transform: 'scale(1.05)',
                            boxShadow: `0 0 0 8px ${alpha('#4caf50', 0)}`,
                        },
                    },
                    '&:hover': {
                        background: (theme) =>
                            `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.15)} 0%, ${alpha(
                                theme.palette.warning.main,
                                0.15
                            )} 100%)`,
                    },
                }}
            />
        </Tooltip>
    );
}

BirthdayBanner.propTypes = {
    userName: PropTypes.string.isRequired,
};
